// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/support_message.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { LiteCustomer } from "../../user/v1/customer_pb.js";

/**
 * @generated from enum gportal.api.support.v1.SupportMessageRating
 */
export enum SupportMessageRating {
  /**
   * @generated from enum value: SUPPORT_MESSAGE_RATING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_RATING_POSITIVE = 1;
   */
  POSITIVE = 1,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_RATING_NEGATIVE = -1;
   */
  NEGATIVE = -1,
}
// Retrieve enum metadata with: proto3.getEnumType(SupportMessageRating)
proto3.util.setEnumType(SupportMessageRating, "gportal.api.support.v1.SupportMessageRating", [
  { no: 0, name: "SUPPORT_MESSAGE_RATING_UNSPECIFIED" },
  { no: 1, name: "SUPPORT_MESSAGE_RATING_POSITIVE" },
  { no: -1, name: "SUPPORT_MESSAGE_RATING_NEGATIVE" },
]);

/**
 * @generated from message gportal.api.support.v1.SupportMessage
 */
export class SupportMessage extends Message<SupportMessage> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: bool is_customer = 2;
   */
  isCustomer = false;

  /**
   * @generated from field: string message = 5;
   */
  message = "";

  /**
   * @generated from field: gportal.api.support.v1.SupportMessageRating rating = 6;
   */
  rating = SupportMessageRating.UNSPECIFIED;

  /**
   * @generated from field: optional google.protobuf.Timestamp created = 7;
   */
  created?: Timestamp;

  /**
   * @generated from field: gportal.api.user.v1.LiteCustomer customer = 9;
   */
  customer?: LiteCustomer;

  /**
   * Files attached to this message. Populated for Intercom tickets only, and in both directions —
   * an agent attaching a config file comes back through the same field as a customer's screenshot.
   * Always empty for legacy tickets, which have no attachment support at all.
   *
   * @generated from field: repeated gportal.api.support.v1.SupportMessageAttachment attachments = 10;
   */
  attachments: SupportMessageAttachment[] = [];

  constructor(data?: PartialMessage<SupportMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_customer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "rating", kind: "enum", T: proto3.getEnumType(SupportMessageRating) },
    { no: 7, name: "created", kind: "message", T: Timestamp, opt: true },
    { no: 9, name: "customer", kind: "message", T: LiteCustomer },
    { no: 10, name: "attachments", kind: "message", T: SupportMessageAttachment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportMessage {
    return new SupportMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportMessage {
    return new SupportMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportMessage {
    return new SupportMessage().fromJsonString(jsonString, options);
  }

  static equals(a: SupportMessage | PlainMessage<SupportMessage> | undefined, b: SupportMessage | PlainMessage<SupportMessage> | undefined): boolean {
    return proto3.util.equals(SupportMessage, a, b);
  }
}

/**
 * One file attached to a support message, as Intercom reports it back.
 *
 * @generated from message gportal.api.support.v1.SupportMessageAttachment
 */
export class SupportMessageAttachment extends Message<SupportMessageAttachment> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string content_type = 2;
   */
  contentType = "";

  /**
   * Where the file can be fetched. Intercom-hosted; treat it as sensitive — it identifies a specific
   * customer's upload.
   *
   * @generated from field: string url = 3;
   */
  url = "";

  /**
   * Size in bytes, as reported by Intercom rather than computed here.
   *
   * @generated from field: uint64 filesize = 4;
   */
  filesize = protoInt64.zero;

  constructor(data?: PartialMessage<SupportMessageAttachment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportMessageAttachment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "filesize", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportMessageAttachment {
    return new SupportMessageAttachment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportMessageAttachment {
    return new SupportMessageAttachment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportMessageAttachment {
    return new SupportMessageAttachment().fromJsonString(jsonString, options);
  }

  static equals(a: SupportMessageAttachment | PlainMessage<SupportMessageAttachment> | undefined, b: SupportMessageAttachment | PlainMessage<SupportMessageAttachment> | undefined): boolean {
    return proto3.util.equals(SupportMessageAttachment, a, b);
  }
}

